import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingHero, LandingParagraph} from '@tempo/landing';
import {tempo} from '@tempo/core';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {useAuthLink} from '@app/hooks/use-link';

const Svg = tempo('svg');

export const HeroBlock: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['remuneration', 'common']});
	const {getRegistrationLink} = useAuthLink();

	return (
		<LandingHero
			position="relative"
			overflow="hidden"
			pt="40px"
			pb="60px"
			_before={{
				content: '""',
				width: '100%',
				height: '400px',
				top: '0',
				bg: 'background.accent.primary.default',
				zIndex: -1,
				position: 'absolute',
			}}
		>
			<Svg
				viewBox="0 0 1615 295"
				fill="none"
				position="absolute"
				minWidth={{base: '760px', md: '1700px'}}
				zIndex="-1"
				left="50%"
				top="175px"
				transform="translate(-50%,0)"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M-0.000734907 147.319C-0.000736279 228.52 361.38 294.346 807.166 294.346C1252.95 294.346 1614.33 228.52 1614.33 147.32C1614.33 66.1191 1252.95 0.29294 807.167 0.292905C361.38 0.29287 -0.000733534 66.1189 -0.000734907 147.319Z"
					fill="#A238FF"
				/>
			</Svg>
			<Svg
				maxWidth={{base: '100%', md: '410px'}}
				height="139"
				viewBox="0 0 596 139"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				overflow="hidden"
			>
				<path
					d="M159.686 127C163.936 86.45 169.186 47.95 175.436 11.5H212.336C218.736 49.45 223.961 87.95 228.011 127H202.811C202.561 122.25 202.136 115.125 201.536 105.625H185.636C185.036 115.125 184.611 122.25 184.361 127H159.686ZM200.186 86.05C198.636 66.2 196.811 47.2 194.711 29.05H192.461C190.561 45.8 188.761 64.8 187.061 86.05H200.186ZM264.888 128.5C258.238 128.5 252.338 126.025 247.188 121.075C242.038 116.075 238.013 109.1 235.113 100.15C232.263 91.15 230.838 80.85 230.838 69.25C230.838 57.65 232.263 47.375 235.113 38.425C238.013 29.425 242.038 22.45 247.188 17.5C252.338 12.5 258.238 10 264.888 10C270.388 10 275.313 11.75 279.663 15.25C284.013 18.7 287.613 23.6 290.463 29.95C293.363 36.3 295.438 43.775 296.688 52.375L272.538 55.225C272.188 49.675 271.713 45.275 271.113 42.025C270.563 38.775 269.813 36.4 268.863 34.9C267.913 33.4 266.688 32.65 265.188 32.65C263.238 32.65 261.688 33.85 260.538 36.25C259.438 38.65 258.613 42.5 258.063 47.8C257.563 53.1 257.313 60.25 257.313 69.25C257.313 78.25 257.563 85.4 258.063 90.7C258.613 96 259.438 99.85 260.538 102.25C261.688 104.65 263.238 105.85 265.188 105.85C266.688 105.85 267.913 105.1 268.863 103.6C269.813 102.1 270.563 99.725 271.113 96.475C271.713 93.225 272.188 88.825 272.538 83.275L296.688 86.125C295.438 94.725 293.363 102.2 290.463 108.55C287.613 114.9 284.013 119.825 279.663 123.325C275.313 126.775 270.388 128.5 264.888 128.5ZM303.539 11.5H330.764C337.964 11.5 344.439 13.125 350.189 16.375C355.939 19.575 360.439 24.025 363.689 29.725C366.939 35.425 368.564 41.85 368.564 49C368.564 56.1 366.939 62.475 363.689 68.125C360.439 73.725 355.939 78.125 350.189 81.325C344.439 84.525 337.964 86.125 330.764 86.125H328.664V127H303.539V11.5ZM330.239 65.125C334.539 65.125 337.814 63.775 340.064 61.075C342.314 58.375 343.439 54.45 343.439 49.3C343.439 44.15 342.314 40.225 340.064 37.525C337.814 34.825 334.539 33.475 330.239 33.475H328.664V65.125H330.239ZM412.599 48.4C412.099 42.7 411.174 38.475 409.824 35.725C408.524 32.925 406.724 31.525 404.424 31.525C402.474 31.525 400.899 32.475 399.699 34.375C398.499 36.225 397.899 38.725 397.899 41.875C397.899 44.475 398.499 46.775 399.699 48.775C400.899 50.775 402.949 52.925 405.849 55.225L417.174 64.225C423.674 69.425 428.399 74.45 431.349 79.3C434.299 84.15 435.774 89.425 435.774 95.125C435.774 101.325 434.374 106.975 431.574 112.075C428.824 117.175 425.049 121.2 420.249 124.15C415.449 127.05 410.124 128.5 404.274 128.5C398.374 128.5 393.149 126.975 388.599 123.925C384.049 120.825 380.349 116.55 377.499 111.1C374.649 105.6 372.699 99.225 371.649 91.975L394.824 89.2C395.824 101.05 398.799 106.975 403.749 106.975C405.899 106.975 407.624 106 408.924 104.05C410.274 102.1 410.949 99.525 410.949 96.325C410.949 93.775 410.324 91.525 409.074 89.575C407.874 87.575 405.824 85.4 402.924 83.05L391.599 74.125C385.149 68.975 380.474 64.025 377.574 59.275C374.724 54.475 373.299 49.2 373.299 43.45C373.299 37.3 374.674 31.675 377.424 26.575C380.174 21.475 383.899 17.45 388.599 14.5C393.349 11.5 398.524 10 404.124 10C409.624 10 414.524 11.5 418.824 14.5C423.174 17.45 426.774 21.6 429.624 26.95C432.474 32.25 434.524 38.45 435.774 45.55L412.599 48.4Z"
					fill="#FDFBFF"
				/>
			</Svg>
			<LandingHeading as="h1" maxWidth="870px">
				{t(
					'acpslandingpage_title_deezerrevolutionizescompensation_standalone-web',
				)}
			</LandingHeading>
			<LandingParagraph color="text.neutral.primary.default" maxWidth="550px">
				{t('acpslandingpage_text_newacpsbenefitsallartists_standalone-web')}
			</LandingParagraph>
			<LandingButtonLink href={getRegistrationLink()} variant="onDark">
				{t('generic_action_signupforfree_standalone-web', {ns: 'common'})}
			</LandingButtonLink>
			<Svg
				viewBox="0 0 1506 542"
				fill="none"
				position="absolute"
				minWidth={{base: '760px', md: '1100px'}}
				zIndex="-1"
				left="50%"
				bottom="0"
				transform="translate(-50%,0)"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M411.965 452.742C411.965 502.015 564.309 541.972 752.238 541.972C940.119 541.972 1092.51 502.037 1092.51 452.742C1092.51 403.469 940.168 363.512 752.238 363.512C564.357 363.512 411.965 403.469 411.965 452.742Z"
					fill="#A238FF"
				/>
				<path
					d="M179.693 298.914C179.693 379.5 436.207 444.829 752.634 444.829C1069.06 444.829 1325.57 379.5 1325.57 298.914C1325.57 218.328 1069.06 153 752.634 153C436.207 153 179.693 218.328 179.693 298.914Z"
					fill="#A238FF"
				/>
				<path
					d="M0.658936 157.456C0.658934 244.181 337.532 314.486 753.086 314.486C1168.64 314.486 1505.51 244.181 1505.51 157.456C1505.51 70.7307 1168.64 0.425753 753.086 0.42572C337.532 0.425688 0.658937 70.7306 0.658936 157.456Z"
					fill="#A238FF"
				/>
			</Svg>
		</LandingHero>
	);
};
